// Generated by scripts/generate_navigation_contract.py; contract SHA-256: e9f1a5dd054abd08286f3b827e7a33bab4e307b36e9d70fee72548135f463a32. Do not edit.
export const NAVIGATION_CONTRACT_VERSION = 1 as const;

export const NAVIGATION_ID_SEGMENTS = {
  "conversation": "conversation",
  "request": "request",
  "ledger-request": "ledger-request",
  "run": "run",
  "result": "result",
  "artifact": "artifact",
  "alert": "alert",
  "job": "job",
  "notice": "notice",
} as const;

export const NAVIGATION_SUBJECT_DESTINATIONS = {
  "note": "note",
  "conversation": "conversation",
  "request": "request",
  "ledger-request": "ledger-request",
  "run": "run",
  "result": "result",
  "artifact": "artifact",
  "source": "source",
  "shim_account": "source",
  "integration": "source",
  "job": "job",
  "ledger-notification": "notice",
} as const;

export const NAVIGATION_SUBJECT_INDEXES = {
  "device": "sources",
  "tenant": "sources",
} as const;

export const NAVIGATION_FIXTURES = [
  "vault",
  "vault?filter=today",
  "vault?filter=pinned",
  "vault?filter=recent",
  "vault?filter=queued",
  "vault?filter=conflict",
  "vault/note/note-1",
  "vault/search?q=quarterly+plan&mode=exact",
  "vault/search?q=quarterly+plan&mode=semantic",
  "conversation/conv-1",
  "request/req-1",
  "ledger-request/ledger-1",
  "run/run-1",
  "result/res-1",
  "artifact/art-1",
  "job/request-drain",
  "notice/notice-1",
  "alerts",
  "alerts/history",
  "questions",
  "alert/alert-1",
  "sources",
  "sources/gmail",
  "account"
] as const;

export const JOB_PHASES = {
  "running": {
    "phase": "active",
    "headline": "Running",
    "detail": "The job has checked in at start and not yet at end.",
    "needsAttention": false
  },
  "ok": {
    "phase": "settled",
    "headline": "Healthy",
    "detail": "The last run finished and the ledger agrees.",
    "needsAttention": false
  },
  "failed": {
    "phase": "settled",
    "headline": "Failed",
    "detail": "The job reported a failed run. Read its own log for why.",
    "needsAttention": true
  },
  "answered_unconsumed": {
    "phase": "settled",
    "headline": "Answer not acted on",
    "detail": "Somebody replied and the job did not act on it. The answer is still readable.",
    "needsAttention": true
  },
  "quiet": {
    "phase": "settled",
    "headline": "Quiet",
    "detail": "The run resolved nothing while work was pending. Check that the job can still read its brief and reach its tools.",
    "needsAttention": true
  },
  "overdue": {
    "phase": "waiting",
    "headline": "Overdue",
    "detail": "No check-in for longer than the job's cadence plus grace. Check that the schedule is still installed and its token still authenticates.",
    "needsAttention": true
  }
} as const;
